import React from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddCategory } from "./FormAddCategory";

export const PanelAddCategory = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add category</div>
          </div>
        }
      />
      <PanelBody content={<FormAddCategory />} />
    </div>
  );
};
